export default "__VITE_ASSET__BLFj$JXO__"